"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = useRenderCellViews;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var utils_1 = require("@doshexchnage/utils");
var react_2 = require("react");
var react_router_dom_1 = require("react-router-dom");
var routes_1 = require("../../../../../../../constants/routes");
var constants_1 = require("../../../constants");
var kindColors = {
    grant: "success",
    revoke: "danger",
    consume: "warning",
    expire: "default",
};
function SignedAmount(_a) {
    var kind = _a.kind, amount = _a.amount;
    if (!amount)
        return (0, jsx_runtime_1.jsx)("div", { className: "text-sm text-muted", children: "0" });
    var isGrant = kind === "grant";
    return ((0, jsx_runtime_1.jsxs)("div", { className: "text-nowrap text-sm font-semibold ".concat(isGrant ? "text-success" : "text-danger"), children: [isGrant ? "+" : "-", amount.toLocaleString()] }));
}
function useRenderCellViews() {
    var renderCellViews = (0, react_2.useCallback)(function (transaction) {
        var _a;
        return [
            { key: "created_at", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-default-foreground", children: (0, utils_1.formatDateTime)(new Date(transaction.created_at)) }) },
            {
                key: "user_name",
                content: ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.CUSTOMERS_ROUTE, "/").concat(transaction.user_id), className: "text-nowrap text-sm font-medium text-accent hover:underline", children: transaction.user_name || transaction.user_id })),
            },
            {
                key: "item_name",
                content: ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: (0, constants_1.itemPagePath)(transaction.item_type, transaction.item_id), className: "text-nowrap text-sm font-medium text-accent hover:underline", children: transaction.item_name || transaction.item_id })),
            },
            {
                key: "item_type",
                content: ((0, jsx_runtime_1.jsx)(react_1.Chip, { className: "text-nowrap", size: "sm", variant: "soft", children: (0, constants_1.itemTypeLabel)(transaction.item_type) })),
            },
            {
                key: "kind",
                content: ((0, jsx_runtime_1.jsx)(react_1.Chip, { className: "text-nowrap", size: "sm", variant: "soft", color: kindColors[transaction.kind], children: (0, constants_1.itemKindLabel)(transaction.kind) })),
            },
            { key: "quantity", content: (0, jsx_runtime_1.jsx)(SignedAmount, { kind: transaction.kind, amount: transaction.quantity }) },
            { key: "uses", content: (0, jsx_runtime_1.jsx)(SignedAmount, { kind: transaction.kind, amount: (_a = transaction.uses) !== null && _a !== void 0 ? _a : 0 }) },
            {
                key: "source_type",
                content: ((0, jsx_runtime_1.jsx)(react_1.Chip, { className: "text-nowrap", size: "sm", variant: "soft", children: (0, constants_1.itemSourceTypeLabel)(transaction.source_type) })),
            },
            { key: "actor", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-muted", children: transaction.actor || "System" }) },
            { key: "reason", content: (0, jsx_runtime_1.jsx)("div", { className: "max-w-[240px] truncate text-sm text-muted", children: transaction.reason || "None" }) },
        ];
    }, []);
    return (0, react_2.useMemo)(function () { return ({ renderCellViews: renderCellViews }); }, [renderCellViews]);
}
